import { toggleMenuNetwork } from "../../../common/custom";
import { getRoleName, getUserName } from "../../../Utils/types";

export const HeaderNetworkPortal = () => {
  return (
    <div className="top-header">
      <div className="custom-container">
        <div style={{ paddingLeft: "10px" }}>
          <img src="https://live.healthassure.in/ProvidersPortal/networkImages/logo.svg" alt="" />
        </div>
        <div className="provider-profile-dp d-flex align-items-center gap-10">
          <img src="https://live.healthassure.in/ProvidersPortal/images/user.png" alt="" width="40" />
          <div className="profile-details">
            <div className="provider-name font-bold text-highlight lh-10">
              {getUserName()}
            </div>
            <div className="provider-designation font-medium text-black lh-10">
              {getRoleName()}
            </div>
          </div>
        </div>
      </div>
      <div className="toggle-menu">
        <i className="fa-solid fa-bars" onClick={toggleMenuNetwork}></i>
      </div>
    </div>
  );
};
